/**
 * Filter Project Events Offcanvas
 * Offcanvas component for filtering project calendar events
 */

import { Offcanvas, Form, Button, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/light.css';

const FilterProjectEventsOffcanvas = ({
    show,
    onHide,
    eventTypes,
    teamMembers,
    onApply,
    onClear
}) => {
    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header closeButton className='px-4 py-3'>
                <Offcanvas.Title className='display-1'>Filter Events</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='px-4 py-3'>
                <Form>
                    <Row className='gy-2'>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Event Types</Form.Label>
                                <Select
                                    options={eventTypes.map(type => ({
                                        value: type.value,
                                        label: type.label
                                    }))}
                                    placeholder="Select event types"
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    isMulti
                                    isClearable
                                />
                            </Form.Group>
                        </Col>

                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Assigned To</Form.Label>
                                <Select
                                    options={teamMembers}
                                    placeholder="Select team members"
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    isMulti
                                    isClearable
                                />
                            </Form.Group>
                        </Col>

                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Priority</Form.Label>
                                <Select
                                    options={[
                                        { value: 'low', label: 'Low' },
                                        { value: 'medium', label: 'Medium' },
                                        { value: 'high', label: 'High' }
                                    ]}
                                    placeholder="Select priority"
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    isMulti
                                    isClearable
                                />
                            </Form.Group>
                        </Col>

                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Start Date</Form.Label>
                                <Flatpickr
                                    className="form-control"
                                    placeholder="Select start date"
                                    options={{
                                        dateFormat: 'Y-m-d',
                                        allowInput: true
                                    }}
                                />
                            </Form.Group>
                        </Col>

                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>End Date</Form.Label>
                                <Flatpickr
                                    className="form-control"
                                    placeholder="Select end date"
                                    options={{
                                        dateFormat: 'Y-m-d',
                                        allowInput: true
                                    }}
                                />
                            </Form.Group>
                        </Col>

                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Location</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Filter by location"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Offcanvas.Body>
            <div className='offcanvas-footer p-3 border-top'>
                <div className='d-flex justify-content-between align-items-center'>
                    <Button 
                        variant="link" 
                        className='text-decoration-none p-0'
                        onClick={onClear}
                    >
                        Reset All
                    </Button>
                    <Button variant="primary" onClick={onApply}>
                        Apply Filters
                    </Button>
                </div>
            </div>
        </Offcanvas>
    );
};

export default FilterProjectEventsOffcanvas;
